/*************************************************/
/* REVEALED CONTENT                              */
/*************************************************/

export function revealedContent() {
    const toggleSelector = '.revealed-content__toggle';
    const itemSelector = '.revealed-content__item';
    const labelSelector = '.revealed-content__toggle-label';
    const itemExpandedClass = 'revealed-content__item--expanded';
    const resizeDebounce = 150;

    const setPanelState = (panel, expanded) => {
        panel.style.maxHeight = expanded ? `${panel.scrollHeight}px` : '0px';
        panel.setAttribute('aria-hidden', !expanded);
    };

    const isExpanded = (toggle) => toggle.getAttribute('aria-expanded') === 'true';

    const init = () => {
        const toggles = [...document.querySelectorAll(toggleSelector)];
        if (!toggles.length) return;

        const panels = [];

        toggles.forEach(toggle => {
            const panel = document.getElementById(toggle.getAttribute('aria-controls'));
            if (!panel) return;

            const item = toggle.closest(itemSelector);
            const label = toggle.querySelector(labelSelector) || toggle;

            panels.push({ toggle, panel });
            setPanelState(panel, false);

            toggle.addEventListener('click', () => {
                const expanded = !isExpanded(toggle);

                toggle.setAttribute('aria-expanded', expanded);
                label.textContent = expanded ? toggle.dataset.labelExpanded : toggle.dataset.labelCollapsed;

                if (item) item.classList.toggle(itemExpandedClass, expanded);

                setPanelState(panel, expanded);
            });
        });

        let resizeTimer;
        window.addEventListener('resize', () => {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(() => {
                panels.forEach(({ toggle, panel }) => {
                    if (isExpanded(toggle)) setPanelState(panel, true);
                });
            }, resizeDebounce);
        });
    };

    init();
}
